<template>
	<div>		
		<v-content>			      
				<center><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="productSalesList == ''"  /></center>
          <v-flex xs3>
            <div class="relative">
              <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
              <v-text-field v-if="productSalesList != '' && search != ''" label="Search" solo single-line v-model="search"></v-text-field>
              <v-text-field append-icon="search" v-if="productSalesList != '' && search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
            </div>               
          </v-flex>			
				<v-data-table :headers="headers" v-if="productSalesList != null && productSalesList != ''" id="hello" :search="search" :items="productSalesList" class="elevation-1 mainTable" style="font-size: 10px;" :rows-per-page-items="[20,40,50,100]">
					<template slot="items" slot-scope="props" v-if="props.item.display == true">                   
                        <td width="40%">{{ props.item.name }}</td>
                        <td width="15%" class="text-xs-right">{{ fncFilterPrice(props.item.gross) }}</td>
                        <td width="15%" class="text-xs-right">{{ fncFilterPrice(props.item.discount) }}</td>
                        <td width="15%" class="text-xs-right">{{ fncFilterPrice(props.item.nett) }}</td>
                        <td width="15%" class="text-xs-right" @click.prevent="props.expanded = !props.expanded"><a @click.prevent="fncViewProducts(props.item.name)"><i class="material-icons">device_hub</i></a></td>
                        <!--<td class="text-xs-right" @click.prevent="props.expanded = !props.expanded"><a @click.prevent="props.expanded = !props.expanded; fncViewProducts(props.item.name)"><i class="material-icons">shopping_cart</i></a></td>-->
                      </template>
                    <template slot="expand" slot-scope="props">                        
                      <v-data-table :headers="productHeaders" :search="search" :items="props.item.children" class="elevation-1 subTable2" style="font-size: 10px;" hide-actions :rows-per-page-items="[20000]">
                        <template slot="items" slot-scope="props" v-if="props.item.display == true">
                          <td width="23%" v-html="fncFilterName(props.item.name)">{{ fncFilterName(props.item.name) }}</td>
                          <td width="11%">{{ props.item.uom }}</td>
                          <td width="11%">{{ fncAveragePrice(props.item.gross,props.item.quantity) }}</td>
                          <td width="11%" class="text-xs-right">{{ fncQuant(props.item.quantity) }}</td>
                          <td width="11%" class="text-xs-right">{{ fncFilterPrice(props.item.gross) }}</td>
                          <td width="11%" class="text-xs-right">{{ fncFilterPrice(props.item.discount) }}</td>
                          <td width="11%" class="text-xs-right">{{ fncFilterPrice(props.item.nett) }}</td>
                          <td width="11%" class="text-xs-right" @click.prevent="props.expanded = !props.expanded"><a @click.prevent="fncViewQuotes(props.item.products, props.item.name)"><i class="material-icons">device_hub</i></a></td>
                        </template>                         
                        <template slot="expand" slot-scope="props">                          
                          <v-data-table :headers="quoteHeaders" :search="search" :items="dateList" class="elevation-1 subTable3" style="font-size: 10px;" hide-actions :rows-per-page-items="[20000]">
                            <template slot="items" slot-scope="props">
                              <td width="10%">{{ props.item.date }}</td>
                              <td width="9%">{{ props.item.quote_no }}</td>
                              <td width="9%">{{ props.item.status }}</td>
                              <td width="9%">{{ props.item.tender_status }}</td>
                              <td width="9%">{{ props.item.originator_name }}</td>
                              <td width="9%">{{ props.item.customer_name }}</td>
                              <td width="9%">{{ props.item.quantity }}</td>
                              <td width="9%" class="text-xs-right">{{ fncFilterPrice(props.item.gross_total) }}</td>
                              <td width="9%" class="text-xs-right">{{ fncFilterPrice(props.item.discount_total) }}</td>
                              <td width="9%" class="text-xs-right">{{ fncFilterPrice(props.item.nett_total) }}</td>
                              <td width="9%" class="text-xs-right"><a @click.prevent="fncViewQuote(props.item)"><i class="material-icons">list_alt</i></a></td>
                            </template>
                          </v-data-table>
                        </template>

                      </v-data-table>		
                    </template>
              </v-data-table>			
		</v-content>	
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex'; 

  export default {
	name: 'ProductSalesLists',
	intRoleEdit: 0,
    data () {
		return {	
          search: '',
          dateList: [],
			headers: [         
				{ text: 'Range Name', value: 'project_name', width: '40%' },
                { text: 'Gross Total', value: 'quote_data', width: '15%', class: 'text-xs-right' },
                { text: 'Discount Total', value: 'created_date', width: '15%', class: 'text-xs-right' },
                { text: 'Nett Total', value: 'project_status', width: '15%', class: 'text-xs-right' },
                { text: 'View Projects', value: 'project_status', width: '15%', class: 'text-xs-right' },
            ],
            productHeaders: [
              { text: 'Product', value: '', width: '23%' },
              { text: 'UOM', value: '', width: '11%' },
              { text: 'Avg Unit Price', value: '', width: '11%' },
              { text: 'Quantity', value: '', width: '11%', class: 'text-xs-right' },
              { text: 'Gross Total', value: '', width: '11%', class: 'text-xs-right' },
              { text: 'Discount Total', value: '', width: '11%', class: 'text-xs-right' },
              { text: 'Nett Total', value: '', width: '11%', class: 'text-xs-right' },
              { text: 'View Quotes', value: '', width: '11%', class: 'text-xs-right' }
            ],
            quoteHeaders: [
              { text: 'Date', value: '', width: '10%' },
              { text: 'Quote No.', value: '', width: '9%' },
              { text: 'Quote Status', value: '', width: '9%' },
              { text: 'Quote Tender Status', value: '', width: '9%' },
              { text: 'Originator', value: '', width: '9%' },
              { text: 'Customer', value: '', width: '9%' },
              { text: 'Quantity', value: '', width: '9%' },
              { text: 'Gross Total', value: '', width: '9%', class: 'text-xs-right' },
              { text: 'Discount Total', value: '', width: '9%', class: 'text-xs-right' },
              { text: 'Nett Total', value: '', width: '9%', class: 'text-xs-right' },
              { text: 'View Quote', value: '', width: '9%', class: 'text-xs-right' }
            ]
           /* quoteHeaders = [
              { text: 'Date', value: '' },
              { text: 'Quote No.', value: '' },
              { text: 'Quote Status', value: '' },
              { text: 'Quote Tender Status', value: '' },
              { text: 'Originator', value: '' },
              { text: 'Customer', value: '' },
              { text: 'Quantity', value: '' },
              { text: 'Gross Total', value: '' },
              { text: 'Discount Total', value: '' },
              { text: 'Nett Total', value: '' },
              { text: 'View Quote', value: '' },
            ]*/
            /*,
            prodHeaders = [
              { text: 'Product', value: '' },
              { text: 'UOM', value: '' },
              { text: 'Avg Unit Price', value: '' },
              { text: 'Quantity', value: '' },
              { text: 'Gross Total', value: '' },
              { text: 'Discount Total', value: '' },
              { text: 'Nett Total', value: '' },
              { text: 'View', value: '' }
            ]*/
		}		
	},
    methods: {	
      fncClearSearch() {
        this.search = '';        
      },
        fncQuant( filterVar ) {
          return parseInt( filterVar );
        },
		fncFilterPrice( filterVar ) {
			var currencyValue = parseFloat(filterVar).toFixed(2);
			currencyValue = currencyValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
			return 'R' + currencyValue;
		},
        fncViewProducts(rangeName) {  
          this.$store.commit('fncHideProjectSales', rangeName);
            /*var modalDetails = { title: 'Product Sales - ' + rangeName, component: 'modal-product-sales-products', mstate: true, params: {rangeName: rangeName} };
            this.$store.dispatch('fncPopulateStatusList');
            this.$store.commit({
                type: 'setModal',
                details: modalDetails
            });*/
            this.$store.dispatch({
              type: 'fncSalesProducts',
              range: rangeName
            })
            this.$store.commit('fncSetProductSaleRange', rangeName)
        },
        fncViewQuotes(products, name) {
          this.$store.commit('fncHideProducts', name);
          this.dateList = [];
          for (var k in products) {            
            this.dateList.push(products[k]);
          }
          /*console.log(name);
          console.log( products );*/
        },
        fncFilterName(name) {
          var dataUrl = name.replace(/%20/g, " ");
          dataUrl = dataUrl.replace(/%27/g, "'");
          dataUrl = dataUrl.replace(/%3A/g, ":");
          dataUrl = dataUrl.replace(/%3B/g, ";");
          dataUrl = dataUrl.replace(/%3C/g, "<");
          dataUrl = dataUrl.replace(/%3D/g, "=");
          dataUrl = dataUrl.replace(/%3E/g, ">");
          dataUrl = dataUrl.replace(/%2C/g, ",");
          dataUrl = dataUrl.replace(/%28/g, "(");
          dataUrl = dataUrl.replace(/%29/g, ")");

          return dataUrl;
        },
        fncViewDates(products) {         
          this.dateList = [];
          for (var k in products) {
            this.productFilter = products[k].product_name;
            this.dateList.push(products[k]);
          }
        },
        fncAveragePrice(total, quantity) {
          var avgPrice = parseFloat(parseInt(total) / parseFloat(quantity)).toFixed(2);
          return 'R' + avgPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },
        fncViewQuote(quoteId) {
          this.$store.commit('hideModal');
          var modalDetails = { title: 'Quote Details - #' + quoteId, component: 'modal-quote-details', mstate: true, params: {} };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
          this.$store.dispatch({
            type: 'fncSetQuoteDetails',
            quoteId: quoteId.quote_id,
            quote: quoteId
          });
        }
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'productSalesList'			
		])
	},
	beforeMount() {
		this.$store.dispatch('fncPopulateProductSalesList');
	}
}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>